export default {
	passwordPattern: /^(?=.*[a-zA-Z_].*)(?=.*[0-9].*)[\w#@%&$]{8,}$/i,
	extractArrayIndexPattern: /\[[\d+$]\]/g,
	phoneNumberPattern: /^\d{7}\d*$/,
	faxNumberPattern: /^\+?[0-9]{7,}$/,
	lettersOnlyPattern: /^[a-zA-z]+$/,
	spacedNames: /^[a-zA-z\s-]+$/,
	businessEmailPattern: /^(?!(gmail|hotmail|icloud|yahoo|outlook|yandex|aol|msn|live\.com|mail\.com|mac\.com))\S+/,
	urlPattern: /(https?:\/\/)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#()?&//=]*)/
};
